<template>
  <alert-message :type="alert.type" :message="alert.message" v-if="showAlert"></alert-message>
  <el-card class="box-card detail-screen">
    <el-row class="title">
      <el-col :span="24">{{ shop.name }} ({{ shop.id }})</el-col>
    </el-row>
    <el-row class="row-data" align="middle" v-if="site != $siteType.site_partner">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.company_name') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.company.name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.genre') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.genre_name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.seat') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.seat_name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.representative_name') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.representative_name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.address') }}</span></el-col>
      <el-col :span="19">
        <span>{{ shop.zipcode_formated }}</span><br>
        <span>{{ shop.address }}</span>
      </el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.tel') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.tel }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.mail_address') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.mail_address }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.homepage_url') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.homepage }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.memo') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.memo }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.description') }}</span></el-col>
      <el-col :span="19"><span class="description">{{ shop.description }}</span></el-col>
    </el-row>
    <!-- <el-row class="row-data" v-if="site != $siteType.site_partner">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.checkin_url') }}</span></el-col>
      <el-col :span="19">
        <span class="checkin-link">{{ shop.checkin_link }}</span> <br>
        <vue-qrcode :value="shop.checkin_link" :options="{ width: 120 }"></vue-qrcode>
      </el-col>
    </el-row> -->
    <el-row class="row-data" v-if="site != $siteType.site_partner">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.checkin_liff') }}</span></el-col>
      <el-col :span="19">
        <span class="checkin-link">{{ shop.checkin_liff }}</span> <br>
        <vue-qrcode :value="shop.checkin_liff" :options="{ width: 120 }"></vue-qrcode>
      </el-col>
    </el-row>
    <el-row class="row-data" v-if="site == $siteType.site_admin || (site == $siteType.site_partner && [$userRole.partner.company, $userRole.partner.shop].includes(role))">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.checkin_url_create_staff') }}</span></el-col>
      <el-col :span="19">
        <span class="checkin-link">{{ shop.checkin_create_staff_link }}</span> <br>
        <vue-qrcode :value="shop.checkin_create_staff_link" :options="{ width: 120 }"></vue-qrcode>
      </el-col>
    </el-row>
    <div class="group-input mt-0" v-if="site != $siteType.site_partner"><span>{{ $t('companies.form.bank_info') }}</span></div>
    <div v-if="site != $siteType.site_partner">
      <el-row class="row-data" align="middle">
        <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.bank_name') }}</span></el-col>
        <el-col :span="19"><span class="font-weight-700">{{ shop.company.bank_name }}</span></el-col>
      </el-row>
      <el-row class="row-data" align="middle" >
        <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.branch_name') }}</span></el-col>
        <el-col :span="19"><span class="font-weight-700">{{ shop.company.branch_name }}</span></el-col>
      </el-row>
      <el-row class="row-data" align="middle">
        <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.bank_account_type') }}</span></el-col>
        <el-col :span="19"><span class="font-weight-700">{{ shop.company.bank_account_type_name }}</span></el-col>
      </el-row>
      <el-row class="row-data" align="middle">
        <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.bank_account') }}</span></el-col>
        <el-col :span="19"><span class="font-weight-700">{{ shop.company.bank_account }}</span></el-col>
      </el-row>
      <el-row class="row-data" align="middle">
        <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.bank_account_holder') }}</span></el-col>
        <el-col :span="19"><span class="font-weight-700">{{ shop.company.bank_account_holder }}</span></el-col>
      </el-row>
    </div>
    <div class="group-input mt-0">
      <el-row>
        <el-col :span="12">
          <span>{{ $t('shops.form.account_info') }}</span>
        </el-col>
        <el-col :span="12" class="reset-account"  v-if="site != $siteType.site_partner">
          <span @click="resetAccount">{{ $t('reset_account_info')}}</span>
        </el-col>
      </el-row>
    </div>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.register_date') }}</span></el-col>
      <el-col :span="19"><span>{{ formatDate(this.shop.created_at) }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.last_login_date') }}</span></el-col>
      <el-col :span="19"><span>{{ formatDate(this.shop.user_partner_last_login_datetime) }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.login_id') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.login_id }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.password') }}</span></el-col>
      <el-col :span="19"><span>**********</span></el-col>
    </el-row>
    <el-row class="row-data" :class="!this.role ? '' : 'last-row'" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.status') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.status_name }}</span></el-col>
    </el-row>
    <el-row class="row-data last-row" align="middle" v-if="!this.role">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.is_display') }}</span></el-col>
      <el-col :span="19"><span>{{ shop.is_display == '1' ? $t('shops.show') : $t('shops.hide') }}</span></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="text-center mt-35">
       <el-button type="primary" @click="redirectEdit" class="btn btn-edit" v-if="this.role !== this.$userRole.partner.shop">{{ $t('update') }}</el-button>
       <el-button @click="back" class="btn btn-back">{{ $t('back') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
  <dialog-reset-account
    v-if="isOpenPopupReset" :openFormReset="true"
    :email="this.shop.mail_address"
    @is-close-popup-reset="handleClosePopupReset"
    @reset-account="handleResetAccount">
  </dialog-reset-account>
</template>
<script>
  import dayjs from 'dayjs';
  import {resetAccount} from '../../api/common'

  export default {
    props: {
      shop: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
      role: { type: Number, required: false },
    },
    data() {
      return {
        isOpenPopupReset: false,
        showAlert: false,
        alert: {
          type: '',
          message: ''
        }
      }
    },
    methods: {
      formatDate(dateTime) {
        return (dateTime) ? dayjs(dateTime).format('YYYY/MM/DD') : '';
      },
      resetAccount() {
        this.isOpenPopupReset = true;
      },
      back() {
         window.location.href = this.urls.index;
      },
      redirectEdit() {
        window.location.href = this.urls.edit;
      },
      handleClosePopupReset() {
        this.isOpenPopupReset = false;
      },
      handleResetAccount() {
        document.querySelector(".el-dialog__body").classList.add("disabled");
        resetAccount(this.shop.mail_address, this.shop.partner_user.login_id, this.$userRole.partner.shop)
        .then(response => response.json())
        .then(response => {
          if (response.status_code === this.$httpStatus.success) {
            this.showAlert = true;
            this.alert = { type: 'completed', message: this.$t('reset_account_completed', [this.shop.mail_address]) }
          }
        })
        .finally(() => {
          document.querySelector(".el-dialog__body").classList.remove("disabled");
          this.isOpenPopupReset = false;
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
  .detail-screen {
    .el-row {
      .el-col {
        span {
          word-break: break-all;
        }
      }
    }
    .description {
      white-space: pre-line;
    }
  }
</style>
